/**
 * @file   src\components\ReplaceDeviceModal.tsx
 * @brief  Replace Device Modal component.
 * @date   January, 2025
 * @author ZCO Engineer
 * @copyright (c) 2025, ZCO
 */
import { Modal, Button, useState, useEffect } from '../utils/thirdpartyComponents';
import CWSelect from './CWSelect';
import '../components/CWModal.scss';
import { addDeviceIDSchema } from '../validations/addDeviceIDSchema';
import * as Yup from 'yup';
import { deviceidFormData } from "../interfaces/generalInterface";
import { AdminOrderHardwareApi } from "../utils/apiUrls";
import { MessageToaster } from "../utils/toastUtil";
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import { DeviceOption, DeviceItem } from '../interfaces/CarWashInterface';
import { CommonMessages } from "../messages/validationMessages"

// Toast object creation.

const ReplaceDeviceModal = (props: any) => {

    const { show, onHide, oldDeviceId, companyDeviceId, deviceType } = props;
    const toaster = new MessageToaster();
    const [loading, setLoading] = useState(false);

    const handleOnHide = () => {
        onHide();
    }
    const [deviceOptions, setdeviceOptions] = useState<DeviceOption[]>([]);
    // Initialise states for fromdata
    const [formData, setFormData] = useState<deviceidFormData>({
        deviceId: 0
    });

    // Initialise states for errors
    const [errors, setErrors] = useState({
        deviceId: '',

    });

    useEffect(() => {
        if (!show || deviceType === undefined || deviceType === null) {
            return;
        }
        getDevices(deviceType);
    }, [show, deviceType]);

    // Triggers on input change
    const handleSelectChange = (selectedOption: any, name: string) => {

        const value = selectedOption?.value || '';
        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setFormData({
            ...formData,
            [name]: value,
        });

    }

    const handleSave = async () => {
        try {
            setLoading(true); // Show loader
            // Validate form data
            await addDeviceIDSchema.validate(formData, { abortEarly: false });
            try {
                const responseDeviceReplace = await axios.post(AdminOrderHardwareApi.REPLACE_ORDER_DEVICE, {
                                        newDeviceId: formData.deviceId,
                                        oldDeviceId: parseInt(oldDeviceId),
                                        companyDeviceId: parseInt(companyDeviceId),
                                    })
                                    ;
                if (responseDeviceReplace?.data?.error === 0) {
                    setErrors({
                        deviceId: '',

                    });
                    toaster.toastSuccess(responseDeviceReplace?.data?.message);
                    onHide();
                }
                else {
                    toaster.toastError(responseDeviceReplace?.data?.message);
                }
            } catch (error) {
                toaster.toastError('Failed to update device.');
            }
        } catch (error) {

            const newErrors: any = {};

            //If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {

                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof formData] = err.message;
                });
                setErrors(newErrors);
            }

        } finally {
            setLoading(false); // Hide loader
        }

    }

    const getDevices = async (type: number | string) => {
        try {
            setLoading(true); // Hide loader
           const { data } = await axios.get(AdminOrderHardwareApi.WASH_BAY_DEVICE_LIST, {
                params: { deviceType: type },
            });
            if (data.error === 0) {
                setLoading(false); // Hide loader
                const device_list: DeviceItem[] = data?.data

                // Transform the array
                const transformedArray: DeviceOption[] = device_list.map(item => ({
                    label: item.deviceName,
                    value: item.washBayDeviceID,
                }));

                setdeviceOptions(transformedArray)
            }
            else {
                // show error message
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            setLoading(false); // Hide loader
            throw new Error(error.response?.data?.message || error.message);
        }
    }
    return (
        <>
            <Modal show={show} onHide={handleOnHide} centered className='add-modal'>
                <Modal.Body>
                    <h5 className='f-bold'>Replace Device</h5>

                    <p className='promo-note mb-3'><span className='fw-bold'>Note:</span> {CommonMessages.device_replace_note} </p>
                        <CWSelect
                            id="deviceid"
                            name="deviceid"
                            options={deviceOptions}
                            label="Select Device"
                            dropdownGap={0}
                            dropdownPosition="auto"
                            placeholder="Select"
                            multi={false}
                            autoFocus
                            isMandatory
                            errorMessage={errors.deviceId}
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions[0], 'deviceId')}
                            className="no-input"
                        />
                        <div className="btn-sec d-grid">
                            <Button title="Cancel" variant="secondary" className='secondary-btn' onClick={handleOnHide}>Cancel</Button>
                            <Button title="Save" variant="primary" className='primary-btn' onClick={ () => handleSave()}>Save</Button>
                        </div>
                        
                   
                </Modal.Body>
            </Modal>
            {loading && <SmallLoader />}
        </>
    );
};
export default ReplaceDeviceModal;
